<template lang="pug">
.plus-gift-contioner(v-if="env.isEasyBikeApp")
  .top-block
    img(src="https://m.hellobike.com/resource/helloyun/08345/_aUz5Qtwfm.png?x-oss-process=image/quality,q_80")
  .card-block
    .card-list(v-for="(item,index) in cardInfo")
      .card-item-block(@click="goUse(item)" :class="{ 'last-item': index === cardInfo.length - 1 }")
        .card-left
          .card-left-biz {{item.goodsPropDesc}}
          .card-left-money
            span.big-money {{item.amount}}
            span.unit {{item.unit}}
        .card-right 去使用
</template>
<script>
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  props: {
    cardInfo: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      env,
    };
  },
  mounted() {

  },
  beforeDestroy() {
  },
  methods: {
    goUse(item) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_gift',
        categoryId: 'platform',
        businessInfo: {
          businessType: item.goodsPropDesc,
        },
      });
      this.$emit('useCard', item);
    },
  },

};
</script>
<style lang="less" scoped>
.plus-gift-contioner {
  background: #fff;
  height: 1.08rem;
  border-radius: 0.16rem;
  border: 0.01rem solid #ebeef0;
  position: relative;

  .top-block {
    width: 2.22rem;
    height: 0.35rem;
    border-radius: 0.16rem 0 0 0;
    background-image: url('https://m.hellobike.com/resource/helloyun/08345/Z3wDzEoWFC.png?x-oss-process=image/quality,q_80');
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      margin-top: 0.11rem;
      margin-left: 0.15rem;
      width: 0.7rem;
      height: 0.18rem;
    }
  }

  .card-block {
    display: flex;
    margin-top: 0.38rem;
    padding-left: 0.13rem;
    overflow: scroll;

    .card-list {
      .card-item-block {
        width: 1.16rem;
        height: 0.58rem;
        background: url(https://m.hellobike.com/resource/helloyun/08345/wwTTNAjvlK.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        margin-right: 0.04rem;
        display: flex;

        .card-left {
          width: 0.8rem;
          text-align: center;

          .card-left-biz {
            margin-top: 0.06rem;
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 400;
            font-size: 0.12rem;
            color: #7d3b2a;
          }

          .card-left-money {
            span.big-money {
              font-family: "DIN Alternate Bold", sans-serif;
              font-weight: bold;
              font-size: 0.26rem;
              color: #fa4614;
              line-height: 0.28rem;
            }

            span.unit {
              font-family: PingFangSC, PingFang SC, sans-serif;
              font-weight: 400;
              font-size: 0.11rem;
              color: #f54311;
              line-height: 0.11rem;
            }
          }
        }

        .card-right {
          margin-right: 0.08rem;
          width: 0.36rem;
          margin-top: 0.1rem;
          writing-mode: vertical-rl;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #fa4614;
        }
      }

      .card-item-block.last-item {
        margin-right: 0.14rem;
      }
    }

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }
  }
}
</style>
